import { Plus, Lock, Unlock, Tag, Trash2 } from "lucide-react";
import { useBoard, boardStore } from "@/lib/boardStore";
import { toast } from "sonner";

export default function Toolbar({ onAdd, onManageCategories }) {
  const { locked, cards } = useBoard();

  const handleClear = () => {
    if (cards.length === 0) return;
    if (!window.confirm("Burn the whole case file? This cannot be undone.")) return;
    boardStore.clearAll();
    toast("Case file incinerated.");
  };

  return (
    <div
      className="absolute top-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-1 bg-[#1a140c]/85 backdrop-blur-md border border-[#5c4426]/50 rounded-full px-2 py-1.5 shadow-[0_8px_28px_rgba(0,0,0,0.6)]"
      data-testid="top-toolbar"
    >
      <button
        onClick={onAdd}
        data-testid="add-card-btn"
        className="flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#c9702a] hover:bg-[#e08432] text-[#1a140c] font-semibold text-sm  transition-colors"
      >
        <Plus size={16} strokeWidth={3} />
        New Node
      </button>

      <div className="w-px h-6 bg-[#5c4426]/50 mx-1" />

      <button
        onClick={onManageCategories}
        data-testid="manage-categories-btn"
        className="flex items-center gap-2 px-3 py-1.5 rounded-full text-[#f4d9a8] hover:bg-[#5c4426]/40 text-sm transition-colors"
      >
        <Tag size={14} />
        Categories
      </button>

      <button
        onClick={() => {
          boardStore.toggleLock();
          toast(locked ? "Board unlocked" : "Board locked — safe to present");
        }}
        data-testid="lock-toggle-btn"
        className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm transition-colors ${
          locked
            ? "bg-[#8b1a1a] text-[#fbe6cb] hover:bg-[#a02020]"
            : "text-[#f4d9a8] hover:bg-[#5c4426]/40"
        }`}
      >
        {locked ? <Lock size={14} /> : <Unlock size={14} />}
        {locked ? "Locked" : "Lock"}
      </button>

      <div className="w-px h-6 bg-[#5c4426]/50 mx-1" />

      <button
        onClick={handleClear}
        data-testid="clear-board-btn"
        className="flex items-center gap-2 px-3 py-1.5 rounded-full text-[#c9b285] hover:bg-[#5c4426]/40 text-sm typewriter transition-colors"
        title="Clear the entire board"
      >
        <Trash2 size={14} />
      </button>
    </div>
  );
}
